import {create, useStore} from 'zustand';
import {combine, persist} from 'zustand/middleware';
import {DEBUG_SETTINGS_STORE_KEY} from '@/constants/storage';

export type DebugSettingsState = {
  debugModelVersion: string | null;
};

export type DebugSettingsStateMethods = {
  setDebugModelVersion: (version: string | null) => void;
  resetAll: () => void;
};

export type DebugSettingsStore = DebugSettingsState & DebugSettingsStateMethods;

const initialState: DebugSettingsState = {
  debugModelVersion: null,
};

const DebugSettingsStore = create(
  persist(
    combine<DebugSettingsState, DebugSettingsStateMethods>(initialState, set => ({
      setDebugModelVersion: (debugModelVersion: string | null) => set({debugModelVersion}),
      resetAll: () => set(initialState),
    })),
    {name: DEBUG_SETTINGS_STORE_KEY},
  ),
);

export const useDebugSettings = <U>(selector: (state: DebugSettingsStore) => U) =>
  useStore(DebugSettingsStore, selector);

export const getDebugSettings = (): DebugSettingsStore => DebugSettingsStore.getState();
